export enum GFEStatus {
  SCHEDULED = "Scheduled",
  INTAKE = "Intake",
  PROCESSING = "Processing",
  PENDING_REVIEW = "Pending Review",
  APPROVED = "Approved",
  REJECTED = "Rejected",
  COMPLETED = "Completed",
  COMPLETED_IN_CLINIC = "Completed in clinic",
  CANCELLED = "Cancelled",
  CANCELLED_BY_CLIENT = "Cancelled by client",
  PROVIDER_CANCELLED = "Provider Cancelled",
}
